import { createSelector } from "reselect";

const getDGIData = (state) =>
  __IS_COMPONENTS_PORTAL__
    ? state &&
      state.variantResult &&
      state.variantResult?.genes?.[state.selectedGeneIndexClinical]?.dgi
    : state && state.variantResult && state.variantResult.dgi;

const getUniqueDGIDrugsNumber = createSelector(getDGIData, (data) => {
  if (!Object.keys(data || {}).length) {
    return null;
  }
  const { items } = data;
  const occurrencesMap = new Map();

  items.forEach((item) => {
    if (occurrencesMap.has(item.id)) {
      occurrencesMap.set(item.id, occurrencesMap.get(item.id) + 1);
    } else {
      occurrencesMap.set(item.id, 1);
    }
  });

  return occurrencesMap.size;
});

export { getDGIData, getUniqueDGIDrugsNumber };
